import type { Banner } from "../../../../app/scripts/tools/banner.types"

type SetBanner = {
  type: "SET_BANNERS"
  payload: {
    banners: Banner[]
    showOnMobile: boolean
  }
}
type RemoveBanner = {
  type: "REMOVE_BANNER"
  payload: {
    index: number
  }
}

export type Action = SetBanner | RemoveBanner

export const setBanner = (banners: Banner[], showOnMobile: boolean): SetBanner => ({
  type: "SET_BANNERS",
  payload: { banners, showOnMobile },
})

export const removeBanner = (index: number): RemoveBanner => ({
  type: "REMOVE_BANNER",
  payload: { index },
})
